import { IGetPureBoxesResult } from '../data/utils';
import { IPoint2d } from '../math/IPoint2d';
import { IRotatedBoxPure } from '../types';
import { EEntityStatus, ETransformType } from '../types/entity';

export enum Entity3dType {
  wallFace = 'wallFace',
  wallOtherFace = 'wallOtherFace',
  columnFace = 'columnFace',
  cylinderFace = 'cylinderFace',
  regionFace = 'regionFace',
  otherFace = 'otherFace',
  glassFace = 'glassFace'
}

export enum EFaceType {
  WallFace = 'wallFace',
  SepWallFace = 'sepWallFace',

  RegionFace = 'regionFace',
  ColumnFace = 'ColumnFace',
  CylinderFace = 'CylinderFace',
  HoleFace = 'HoleFace',
  // GlassFace = 'GlassFace',
  FloorFace = 'FloorFace'
  // OtherFace = 'otherFace'
}

export enum WallFaceType {
  innerFace = 'innerFace',
  outerFace = 'outerFace',
  other = 'other'
}

export enum EEnableScaleMode {
  Empty = 'empty', // 不启用
  All = 'all', // 全部启用
  Corner = 'corner', // 四角矩形
  Edge = 'edge', // 四边矩形
  LeftRight = 'leftRight' // 左右矩形
}

export interface ITransformEntityParams extends Pick<IGetPureBoxesResult, 'boxes' | 'rotation'> {
  width: number;
  height: number;
  center: IPoint2d;
  status: EEntityStatus;
  transformType: ETransformType;
  forceUpdate: boolean;
  enableScaleMode: EEnableScaleMode;
  enableRotation: boolean;
}

export interface IBoxOutlineParams extends IRotatedBoxPure {
  color: number;
  linewidth: number;
  /** 不传按 `ENTITY_RENDER_ORDER.selectedOutline` 渲染 */
  renderOrder?: number;
}

export enum EIndicatorSide {
  up = 'up',
  left = 'left',
  down = 'down',
  right = 'right'
}

export interface IIndicatorEntityParams {
  center: IPoint2d;
  label: string;
  side: EIndicatorSide;
  forceUpdate?: boolean;
}
